import { render, staticRenderFns } from "./MmlQaSearchPage.vue?vue&type=template&id=bbf356d4&"
import script from "./MmlQaSearchPage.vue?vue&type=script&lang=js&"
export * from "./MmlQaSearchPage.vue?vue&type=script&lang=js&"
import style0 from "./MmlQaSearchPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports